export enum MembershipType {
    STARTER = `STARTER`,
    UPME = `UPME`,
}
